import { TEMPLATE_ACCENT_DEFAULTS } from '@cibli/shared';
import { z } from 'zod';

export const moderneParamsSchema = z.object({
  accentColor: z.string().default(TEMPLATE_ACCENT_DEFAULTS.september),
  showProfilePicture: z.boolean().default(true),
  headerStyle: z.enum(['stripe', 'badge']).default('stripe'),
  spacing: z.enum(['compact', 'normal', 'aere']).default('normal'),
});

export type ModerneParams = z.infer<typeof moderneParamsSchema>;

export const moderneDefaultParams: ModerneParams = moderneParamsSchema.parse({});
